import React, {useState, useEffect} from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';

import {Copyright} from '../../../components';

import { store } from 'react-notifications-component';
import { withRouter } from "react-router";

import { useFormik } from 'formik';

import {registerCompany, registerUser} from '../../../services/auth.service';
import { useAuth } from "../../../context/auth";
import Helmet from "react-helmet";
import {FormControl, InputLabel, MenuItem} from "@material-ui/core";
import Select from "@material-ui/core/Select";
import {toastWarning} from "../../../utils/utils";
import {LOCAL_STORAGE_KEYS} from "../../../utils/constants";

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

const industry_sectors = [
    'IT',
    'Education',
    'Corporate'
];
const company_sizes = [
    '<10 Employees',
    '10-100 Employees',
    '101-500 Employees',
    '501-1000 Employees',
    '>1000 Employees'
];

const RegisterCompany = (props) => {
    const classes = useStyles();

    const { setAuthToken, setAuthUser } = useAuth();

    const formik = useFormik({
        initialValues: {
            company_name: '',
            industry_or_sector: '',
            company_size: '',
            country: '',
            city: '',
            postal_code: '',
            owner_first_name: '',
            owner_last_name: '',
            owner_position: '',
            owner_email: '',
            password: '',
            confirm_password: ''
        },
        onSubmit: async (values) => {
            console.log('Form data => ', values);
            if (values.password !== values.confirm_password) {
                return store.addNotification({
                    title: "Password MissMatch",
                    message: "Please provide the same password in both password fields!",
                    type: "warning",
                    insert: "bottom",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 2000,
                        showIcon: true
                    }
                });
            }

            try {
                const result = await registerCompany(values);
                if (result.data && result.data.user) {
                    const c_user = result.data.user;
                    c_user.org_obj = result.data.org_object;
                    localStorage.setItem(LOCAL_STORAGE_KEYS.active_org_type, c_user.org_obj.type);
                    localStorage.setItem(LOCAL_STORAGE_KEYS.active_org_code, c_user.org_obj.org_code);
                    await setAuthToken(result.data.auth_token);
                    await setAuthUser(c_user);
                    props.history.push('/');
                }
            } catch (e) {
                // already toasted the error
            }
        }
    });

    return (
        <Container component="main" maxWidth="xs">
            <Helmet title="DQ-PRO | Register[Company]" />
            <CssBaseline />
            <div className={classes.paper}>
                <Avatar className={classes.avatar}>
                    <LockOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h5">
                    Register [Company]
                </Typography>

                <form className={classes.form} noValidate onSubmit={formik.handleSubmit}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                id="company_name"
                                label="Company Name"
                                name="company_name"
                                autoComplete="company_name"
                                onChange={formik.handleChange}
                                value={formik.values.company_name}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl fullWidth variant="outlined" m={2}>
                                <InputLabel

                                    id="demo-simple-select-outlined-label"
                                >Industry / Sector</InputLabel>
                                <Select
                                    required
                                    fullWidth
                                    labelId="demo-simple-select-outlined-label"
                                    id="industry_or_sector"
                                    name="industry_or_sector"
                                    onChange={formik.handleChange}
                                    value={formik.values.industry_or_sector}
                                    label="Industry / Sector"
                                >
                                    { industry_sectors.map(item_type => <MenuItem value={item_type}>{item_type}</MenuItem>) }
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl fullWidth variant="outlined" m={2}>
                                <InputLabel

                                    id="demo-simple-select-outlined-label"
                                >Company Size</InputLabel>
                                <Select
                                    required
                                    fullWidth
                                    labelId="demo-simple-select-outlined-label"
                                    id="company_size"
                                    name="company_size"
                                    onChange={formik.handleChange}
                                    value={formik.values.company_size}
                                    label="Company Size"
                                >
                                    { company_sizes.map(item_type => <MenuItem value={item_type}>{item_type}</MenuItem>) }
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                id="country"
                                label="Country"
                                name="country"
                                autoComplete="country"
                                onChange={formik.handleChange}
                                value={formik.values.country}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                id="city"
                                label="City"
                                name="city"
                                autoComplete="city"
                                onChange={formik.handleChange}
                                value={formik.values.city}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                id="postal_code"
                                label="Postal Code"
                                name="postal_code"
                                autoComplete="postal_code"
                                onChange={formik.handleChange}
                                value={formik.values.postal_code}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                id="owner_first_name"
                                label="Your First Name"
                                name="owner_first_name"
                                autoComplete="owner_first_name"
                                onChange={formik.handleChange}
                                value={formik.values.owner_first_name}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                id="owner_last_name"
                                label="Your Last Name"
                                name="owner_last_name"
                                autoComplete="owner_last_name"
                                onChange={formik.handleChange}
                                value={formik.values.owner_last_name}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                id="owner_position"
                                label="Your Position"
                                name="owner_position"
                                autoComplete="owner_position"
                                onChange={formik.handleChange}
                                value={formik.values.owner_position}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                id="owner_email"
                                label="Your Email"
                                name="owner_email"
                                autoComplete="owner_email"
                                onChange={formik.handleChange}
                                value={formik.values.owner_email}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                name="password"
                                label="Create a Password"
                                type="password"
                                id="password"
                                autoComplete="current-password"
                                onChange={formik.handleChange}
                                value={formik.values.password}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                name="confirm_password"
                                label="Confirm Password"
                                type="password"
                                id="confirm_password"
                                autoComplete="current-password"
                                onChange={formik.handleChange}
                                value={formik.values.confirm_password}
                            />
                        </Grid>
                        <FormControlLabel
                            control={<Checkbox
                                name="remember_me"
                                id="remember_me"
                                value={formik.values.remember_me}
                                onChange={formik.handleChange}
                                color="primary"
                            />}
                            label="Keep me logged In"
                        />
                    </Grid>
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                    >
                        Register
                    </Button>
                    <Grid container justify="flex-end">
                        <Grid item>
                            <Link href="/login" variant="body2">
                                Already have an account? Sign in
                            </Link>
                        </Grid>
                    </Grid>
                </form>

            </div>
            <Box mt={5}>
                <Copyright />
            </Box>
        </Container>
    );
}

export default withRouter(RegisterCompany);